import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css";
import "../css/AboutUs.css";

const AboutUs = () => {
  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchAboutData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_APP_URL}/aboutUs`,
        {
          headers: {
            "X-Platform": process.env.REACT_APP_X_PLATFORM,
            "API-Key": process.env.REACT_APP_API_KEY,
            "X-API-Version": process.env.REACT_APP_X_API_VERSION,
          },
          withCredentials: true,
        }
      );
      if (response.data.success) {
        setAboutData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching about us data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAboutData();
  }, []);

  if (loading) {
    return (
      <div className="container" style={{ marginTop: "80px" }}>
        <div className="shimmer-container">
          <div className="shimmer-image"></div>
          <div className="shimmer-text">
            <div className="shimmer-title"></div>
            <div className="shimmer-line" style={{ width: "90%" }}></div>
            <div className="shimmer-line" style={{ width: "100%" }}></div>
            <div className="shimmer-line" style={{ width: "80%" }}></div>
          </div>
        </div>
      </div>
    );
  }

  if (!aboutData) {
    return (
      <div className="container" style={{ marginTop: "100px" }}>
        <p>no data found</p>
      </div>
    );
  }

  const imageUrl = `${process.env.REACT_APP_STORAGE_URL}/${aboutData.image}`;

  return (
    <div className="container" style={{ marginTop: "100px" }}>
      <div className="row align-items-center">
        <div className="col-md-6 animate__animated animate__fadeInLeft">
          <img
            src={imageUrl}
            alt={aboutData.title}
            className="img-fluid rounded shadow"
          />
        </div>
        <div className="col-md-6 animate__animated animate__fadeInRight">
          <h1 className="fw-bold text-primary mb-4">{aboutData.title}</h1>
          <div
            className="lead text-secondary justify-text text-dark"
            dangerouslySetInnerHTML={{ __html: aboutData.content }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
